(function () {
  const GIFT_1_HANDLE = 'free-gift-1';
  const GIFT_2_HANDLE = 'free-gift-2';
  const GIFT_3_HANDLE = 'free-gift-3';
  const ALL_GIFT_HANDLES = [GIFT_1_HANDLE, GIFT_2_HANDLE, GIFT_3_HANDLE];
  const STICKER_HANDLE = 'academie-sticker-free-with-purchase';
 
  const PROTECTED_HANDLES = new Set([STICKER_HANDLE]);
 
  const QUALIFYING_HANDLES = [
    'girls-academie-jods',
    'academie-jodhpur-boots',
    'karben-silvia-standard-peak-helmet',
    'karben-matteo-helmet',
    'academie-riding-gloves',
  ];
 
  const SIZES = ['XXSmall', 'XSmall', 'Small', 'Medium', 'Large', 'XLarge', 'XXLarge', 'XXXLarge'];
 
  const GIFT_VARIANT_CACHE = {};
  let isSyncing = false;
  let academyPromoHandles = null;
 
  function loadAcademyPromoHandles() {
    if (academyPromoHandles) return Promise.resolve(academyPromoHandles);
    return fetch('/collections/academy-promo/products.json?limit=250')
      .then((r) => r.json())
      .then((data) => {
        academyPromoHandles = new Set(data.products.map((p) => p.handle));
        return academyPromoHandles;
      });
  }
 
  function isGiftItem(item) {
    if (PROTECTED_HANDLES.has(item.handle)) return false;
    return ALL_GIFT_HANDLES.includes(item.handle) && item.final_line_price === 0;
  }
 
  function getQualifyingCount(cart) {
    return cart.items.filter((i) => QUALIFYING_HANDLES.includes(i.handle)).length;
  }
 
  function getExpectedGiftHandle(count) {
    if (count >= 4) return GIFT_3_HANDLE;
    if (count >= 3) return GIFT_2_HANDLE;
    if (count >= 2) return GIFT_1_HANDLE;
    return null;
  }
 
  function getGiftVariantId(handle) {
    if (GIFT_VARIANT_CACHE[handle]) {
      return Promise.resolve(GIFT_VARIANT_CACHE[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then((r) => r.json())
      .then((p) => {
        GIFT_VARIANT_CACHE[handle] = p.variants[0].id;
        return GIFT_VARIANT_CACHE[handle];
      });
  }
 
  function syncSticker(cart, promoHandles) {
    const hasSticker = cart.items.some((i) => i.handle === STICKER_HANDLE);
    const shouldHaveSticker = cart.items.some(
      (i) =>
        promoHandles.has(i.handle) &&
        !PROTECTED_HANDLES.has(i.handle) &&
        !ALL_GIFT_HANDLES.includes(i.handle)
    );
 
    if (shouldHaveSticker && !hasSticker) {
      return getGiftVariantId(STICKER_HANDLE)
        .then((variantId) =>
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                _source: 'rebuy',
                _attribution: 'rebuy-gift-with-purchase',
              },
            }),
          })
        )
        .then((r) => r.json());
    } else if (!shouldHaveSticker && hasSticker) {
      const sticker = cart.items.find((i) => i.handle === STICKER_HANDLE);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [sticker.variant_id]: 0 } }),
      }).then((r) => r.json());
    }
 
    return Promise.resolve();
  }
 
  function renderSizePicker(item, lineIndex) {
    const currentSize = item.properties?.['Requested Size'] || '';
    const options = SIZES.map((size) => {
      const selected = currentSize === size ? 'selected' : '';
      return `<option value="${size}" ${selected}>${size}</option>`;
    }).join('');
 
    return `
      <div class="rebuy-gift-size-picker" data-line="${lineIndex}" data-variant="${item.variant_id}" style="margin-top:10px;">
        <label style="font-size:12px;font-weight:600;display:block;margin-bottom:4px;color:#000;">
          🎁 Free Gift — Select Your Size:
        </label>
        <select
          class="rebuy-gift-size-select"
          data-line="${lineIndex}"
          data-variant-id="${item.variant_id}"
          style="width:100%;padding:6px 10px;border:1.5px solid #000;border-radius:4px;font-size:13px;cursor:pointer;background:#fff;"
          onchange="window.rebuyGiftSaveSize(this)"
        >
          <option value="" disabled ${!currentSize ? 'selected' : ''}>Choose a size...</option>
          ${options}
        </select>
        ${
          !currentSize
            ? `<p style="color:#c0392b;font-size:11px;margin-top:4px;">
                ⚠️ Please select a size for your free gift.
              </p>`
            : ''
        }
      </div>
    `;
  }
 
  window.rebuyGiftSaveSize = function (selectEl) {
    const size = selectEl.value;
    selectEl.disabled = true;
 
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const variantId = parseInt(selectEl.dataset.variantId);
        const gift = cart.items.find((i) => i.variant_id === variantId && isGiftItem(i));
        if (!gift) return;
        const lineIndex = cart.items.indexOf(gift) + 1;
 
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: lineIndex,
            quantity: 1,
            properties: {
              ...gift.properties,
              'Requested Size': size,
              _source: 'rebuy',
              _attribution: 'rebuy-gift-with-purchase',
            },
          }),
        });
      })
      .then((r) => r.json())
      .then(() => {
        selectEl.disabled = false;
        const picker = selectEl.closest('.rebuy-gift-size-picker');
        const warning = picker?.querySelector('p');
        if (warning) warning.remove();
        const label = picker?.querySelector('label');
        if (label) label.innerHTML = '🎁 Free Gift — Size: <strong>' + size + '</strong> ✅';
        setTimeout(injectSizePickers, 500);
      })
      .catch(() => {
        selectEl.disabled = false;
      });
  };
 
  function reconnectObserver() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }
 
  function syncGifts() {
    if (isSyncing) return;
    isSyncing = true;
    observer.disconnect();
 
    Promise.all([
      fetch('/cart.js').then((r) => r.json()),
      loadAcademyPromoHandles(),
    ])
      .then(([cart, promoHandles]) => {
        const qualifyingCount = getQualifyingCount(cart);
        const expectedHandle = getExpectedGiftHandle(qualifyingCount);
        const currentGifts = cart.items.filter(isGiftItem);
        const correctGift = currentGifts.find((i) => i.handle === expectedHandle);
        const wrongGifts = currentGifts.filter((i) => i.handle !== expectedHandle);
        const duplicates = currentGifts.filter((i) => i.handle === expectedHandle).slice(1);
        const toRemove = [...wrongGifts, ...duplicates];
 
        const removePromise =
          toRemove.length > 0
            ? fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  updates: Object.fromEntries(toRemove.map((i) => [i.variant_id, 0])),
                }),
              }).then((r) => r.json())
            : Promise.resolve();
 
        return removePromise.then(() => ({ expectedHandle, correctGift, promoHandles }));
      })
      .then(({ expectedHandle, correctGift, promoHandles }) => {
        const addGiftPromise =
          expectedHandle && !correctGift
            ? getGiftVariantId(expectedHandle)
                .then((variantId) =>
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: variantId,
                      quantity: 1,
                      properties: {
                        _source: 'rebuy',
                        _attribution: 'rebuy-gift-with-purchase',
                      },
                    }),
                  })
                )
                .then((r) => r.json())
            : Promise.resolve();
 
        return addGiftPromise
          .then(() => fetch('/cart.js').then((r) => r.json()))
          .then((freshCart) => syncSticker(freshCart, promoHandles));
      })
      .then(() => {
        isSyncing = false;
        injectSizePickers();
        reconnectObserver();
      })
      .catch(() => {
        isSyncing = false;
        reconnectObserver();
      });
  }
 
  function injectSizePickers() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        cart.items.forEach((item, i) => {
          if (!isGiftItem(item)) return;
 
          const lineIndex = i + 1;
          const giftClass = `product-${item.handle}`;
          const giftEls = document.querySelectorAll(`.rebuy-cart__flyout-item.${giftClass}`);
 
          giftEls.forEach((el) => {
            const existing = el.querySelector('.rebuy-gift-size-picker');
            if (existing && existing.dataset.variant == item.variant_id) return;
            existing?.remove();
 
            const infoEl = el.querySelector('.rebuy-cart__flyout-item-info');
            if (!infoEl) return;
 
            const picker = document.createElement('div');
            picker.innerHTML = renderSizePicker(item, lineIndex);
            infoEl.appendChild(picker.firstElementChild);
          });
        });
      });
  }
 
  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }
 
  const debouncedSync = debounce(syncGifts, 600);
 
  const observer = new MutationObserver(debouncedSync);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style'],
  });
 
  setTimeout(() => {
    let attempts = 0;
    const poll = setInterval(() => {
      syncGifts();
      if (++attempts >= 10) clearInterval(poll);
    }, 800);
  }, 2000);
})();
